import type { PayrollRunTaxReadiness } from '../types';
import { TAX_NOT_READY_FIX, TAX_NOT_READY_TITLE, TAX_READINESS_CODE_LABELS } from '../reviewCopy';

/**
 * EPN-22 prompt 3: shown when the server reports the run's tax results are not ready, so approval is refused. Names each blocked
 * employee (from the register when it has loaded, otherwise by id) and says why and how to fix it. Display only: the server is the
 * authority and refuses approval itself. No Figma frame exists for this state (UX / DESIGN GAP); it uses the page's existing alert panel.
 */
export function TaxReadinessNotice({ readiness, employeeNames }: { readiness: PayrollRunTaxReadiness | null | undefined; employeeNames: ReadonlyMap<string, string> }) {
  if (readiness?.status !== 'NotReady') return null;
  return (
    <div className="payroll-review__panel payroll-review__panel--error" role="alert" aria-labelledby="payroll-review-tax-title">
      <strong id="payroll-review-tax-title">{TAX_NOT_READY_TITLE}</strong>
      <p className="muted">
        {readiness.notReadyCount} of {readiness.calculationCount} employee{readiness.calculationCount === 1 ? '' : 's'} affected.
      </p>
      <ul>
        {readiness.blocked.map((b) => (
          <li key={b.employeeId}>
            {employeeNames.get(b.employeeId) ?? `Employee ${b.employeeId}`}: {b.codes.map((c) => TAX_READINESS_CODE_LABELS[c] ?? c).join('; ')}
          </li>
        ))}
      </ul>
      <p className="muted">{TAX_NOT_READY_FIX}</p>
    </div>
  );
}
